import { processWebsocketContent } from './websocketEvents';

let ws = null;

export function connectWebSocket(container, websocketUrl) {
  if (!websocketUrl) return;

  const subscribeMessage = JSON.stringify({ topic: 'aws/subscribe', content: { topics: ['aws/chat'] } });
  ws = new WebSocket(websocketUrl);

  ws.onopen = () => ws.send(subscribeMessage);

  ws.onmessage = (event) => {
    const msg = JSON.parse(event.data);
    if (msg.topic !== 'aws/chat') return;

    const content = JSON.parse(msg.content);
    processWebsocketContent(container, content);
  };
}

export function disconnectWebSocket() {
  if (ws) {
    ws.close();
    ws = null;
  }
}
